// NG
import angular from 'angular';
import angularAnimate from 'angular-animate';
import angularDialog from 'ng-dialog';
import angularSanitize from 'angular-sanitize';
import uirouter from '@uirouter/angularjs';
import { DSRPlugin } from '@uirouter/dsr';
import ocLazyLoad from 'oclazyload';

// CoreJS
import 'core-js';
import 'regenerator-runtime/runtime';

// Moment
// https://github.com/moment/moment/issues/2608
import moment from 'moment';
window.moment = moment;
import 'moment/locale/en-gb.js';
import 'moment/locale/en-ie.js';
import 'moment/locale/en-ca.js';
import 'moment/locale/en-au.js';
import 'moment/locale/en-nz.js';
import 'moment/locale/nb.js';
import 'moment/locale/nl.js';
import 'moment/locale/fi.js';
import 'moment/locale/da.js';
import 'moment/locale/sv.js';
import 'moment/locale/fr.js';
import 'moment/locale/de.js';
import 'moment/locale/es.js';
import 'moment/locale/pt.js';
import 'moment/locale/pt-br.js';
import 'moment/locale/it.js';
import 'moment/locale/ro.js';
import 'moment/locale/cs.js';
import 'moment/locale/ko.js';
import 'moment/locale/da.js';
import 'moment/locale/ja.js';
import 'moment/locale/pl.js';
import 'moment/locale/zh-cn.js';
import 'moment/locale/zh-tw.js';
import 'moment/locale/ru.js';
import 'moment/locale/vi.js';
import 'moment/locale/ca.js';
import 'moment/locale/id.js';
import 'moment/locale/tr.js';

// Internal / Polyfill
import './components/sticky/sticky.directive.js';
import './polyfill.js';

export default angular.module('weborders.vendor', [
  uirouter,
  ocLazyLoad,
	'ngDialog',
	'ngAnimate',
  'ngSanitize',
  'sticky',
])
.config(($uiRouterProvider) => {
  $uiRouterProvider.plugin(DSRPlugin);
});
